import { render, staticRenderFns } from "./PaginationLeft.vue?vue&type=template&id=5464d7f3&scoped=true&"
import script from "./PaginationLeft.vue?vue&type=script&lang=js&"
export * from "./PaginationLeft.vue?vue&type=script&lang=js&"
import style0 from "./PaginationLeft.vue?vue&type=style&index=0&id=5464d7f3&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5464d7f3",
  null
  
)

export default component.exports